import React from "react";
import { NavLink } from "react-router-dom";
import { Rocket, Sparkles, PlayCircle } from "lucide-react";

const TABS = [
  { to: "/platform/deployments", label: "Deployments", icon: Rocket },
  { to: "/platform/deployments/environments", label: "Environment Configs", icon: Sparkles },
  { to: "/platform/deployments/runs", label: "Deployment Runs", icon: PlayCircle },
];

export default function DeploymentSubNav() {
  return (
    <nav className="mb-5 flex flex-wrap gap-1 border-b border-white/10 pb-1" data-testid="deployment-subnav">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.to === "/platform/deployments"}
          className={({ isActive }) =>
            `inline-flex items-center gap-1.5 px-3 py-2 text-xs font-black uppercase tracking-wider rounded-t-lg border-b-2 -mb-[1px] transition ${
              isActive
                ? "text-emerald-300 border-emerald-400 bg-emerald-500/5"
                : "text-white/50 border-transparent hover:text-white hover:bg-white/5"
            }`
          }
          data-testid={`subnav-${t.label.toLowerCase().split(" ")[0]}`}
        >
          <t.icon size={13} /> {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
